module.exports = __webpack_public_path__ + "static/media/paradise_background_p.e230797d.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/paradise_background_p.png
// module id = 218
// module chunks = 0